<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://ib-labs.co">
              IB Labs lc
            </a>
          </li>
          <!-- <li>
            <a href="https:///ib-labs.co/about">
              About Us
            </a>
          </li> -->
          <!-- <li>
            <a href="https:///blog.ib-labs.co">
              Blog
            </a>
          </li> -->
          <!-- <li>
            <a href="https://ib-labs.co/privacy">
              Privacy Policy
            </a>
          </li> -->
        </ul>
      </nav>
      <div class="copyright">&copy; {{ year }}</div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
